import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { injectRpServiceId } from "@utils/parameter-injector";
import { VerificationServiceChangeRequestResponse } from "@idw-types/data/verification-service";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";

type DeleteVerificationServiceRequestResponse = {
    transferObject: VerificationServiceChangeRequestResponse;
};

export const deleteVerificationServiceRequest = async (
    verificationServiceId: string
): Promise<GenericNetworkResponse<DeleteVerificationServiceRequestResponse>> => {
    const route = injectRpServiceId(apiRoutes.serviceConfiguration.rpServiceConfig.rpService.delete, verificationServiceId);

    const { data, error } = await handleRequest(RequestTypes.POST, route);
    return { data, error };
};